import React, { useMemo } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { ReactTable } from '../../../components/shared';
import { MONTHLY_RECONCILIATION_WEEKLY_POSTINGS } from '../../../constants/tableColumns';
import { calculateMonthlyReconciliationTotals } from '../../../utils/collection-methods';
import { buildMonthlyPostingTableData, buildVarianceTableData } from './helpers/monthlyReconciliationDataHelpers';
import SubLocationVariancePanel from './SubLocationVariancePanel';

const MonthlyReconciliationDataPanel = ({ weeklyPostingsData, selectedProductName, assetWithVarianceData = [] }) => {
  const calculations = useMemo(() => calculateMonthlyReconciliationTotals(weeklyPostingsData), [weeklyPostingsData]);
  const columns = useMemo(() => MONTHLY_RECONCILIATION_WEEKLY_POSTINGS(), []);
  const varianceTableData = useMemo(() => buildVarianceTableData(assetWithVarianceData), [assetWithVarianceData]);

  const dataWithSummary = useMemo(
    () => buildMonthlyPostingTableData(weeklyPostingsData, selectedProductName, calculations),
    [weeklyPostingsData, selectedProductName, calculations],
  );

  if (!weeklyPostingsData || weeklyPostingsData.length === 0) {
    return null;
  }

  return (
    <Paper elevation={0} sx={{ border: '1px solid #E0E0E0' }}>
      <ReactTable columns={columns} data={dataWithSummary} pagination={false} disablePagination={true} />

      {assetWithVarianceData.length > 0 && (
        <Box mt={5} mb={3}>
          <Typography variant="subtitle2" fontWeight={600} mb={2} sx={{ pl: 3 }}>
            Asset-Level Variance Details ({assetWithVarianceData.length} items)
          </Typography>
          <SubLocationVariancePanel data={varianceTableData} />
        </Box>
      )}
    </Paper>
  );
};

export default MonthlyReconciliationDataPanel;
